module.exports = __webpack_public_path__ + "static/media/md-leaf.8654cc46.svg";